/* import __COLOCATED_TEMPLATE__ from './category-title-before.hbs'; */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";

@tagName("")
export default class CategoryTitleBefore extends Component {}
